import * as CronofyElements from "cronofy-elements";
import { useEffect } from "react";
import { useState } from "react";
import { TextField, Typography, Button, InputAdornment, useTheme } from "@mui/material";
import AddIcon from "src/components/logos/addIcon.png";
import ActiveIcon from "src/components/logos/activeIcon.png"
import NoEdit from "src/components/logos/noEdit.png"
import GoogleIcon from "src/components/logos/googleIcon.png";
import AppleIcon from "src/components/logos/appleIcon.png";
import Outlook from "src/components/logos/outlookIcon.png";
import MicrosoftIcon from "src/components/logos/microsoftIcon.png";
import ExchangeIcon from "src/components/logos/exchangeIcon.png";
import "./style.css";

export const CalendarSyncWrapper = ({ options }) => {
  const [element, setElement] = useState(null);
  const theme=useTheme();

  useEffect(() => {
    try {
      if (!element) {
        setElement(CronofyElements.CalendarSync(options));
      }
    } catch (error) {
      //console.log(error);
    }
  }, []);

  useEffect(() => {
    try { 
    if (element && options.element_token) {
      element.update(options);
    }
  } catch (error) {
    //console.log(error);
    
  }
  }, [options]);

  useEffect(() => {
    const id = `cronofy-theme-${options.target_id}`;
    const isDark = theme.palette.mode === "dark";
    const textColor = theme.palette.text.primary;
    const borderColor = isDark ? "rgba(255,255,255,0.12)" : "rgba(0,0,0,0.12)";
    const inputBg = isDark ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.04)";
    const primaryColor = theme.palette.primary.main;

    const css = `
 
 #${options.target_id} button {
  color: ${textColor} !important;
  border-color: ${borderColor} !important;
  padding: 4px 8px !important;
  border-radius: 8px !important;
}

#${options.target_id} button span,
#${options.target_id} button div,
#${options.target_id} button p,
#${options.target_id} button svg {
  color: ${textColor} !important;
  fill: ${textColor} !important;
}

      #${options.target_id} p,
      #${options.target_id} span,
      #${options.target_id} label,
      #${options.target_id} div {
        color: ${textColor} !important;
      }
      #${options.target_id} input,
      #${options.target_id} select,
      #${options.target_id} textarea {
        color: ${textColor} !important;
        background-color: ${inputBg} !important;
        border-color: ${borderColor} !important;
      }
      #${options.target_id} a {
        color: ${primaryColor} !important;
      }
        #${options.target_id} button svg {
  width: 20px !important;
  height: 20px !important;
  font-size: 20px !important;
}
    `;

    let styleEl = document.getElementById(id);
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.id = id;
      document.head.appendChild(styleEl);
    }
    styleEl.textContent = css;

    const target = document.getElementById(options.target_id);
    if (!target) return;

    const addGlass = () => {
      target.querySelectorAll("button").forEach((btn) => {
        if (!btn.classList.contains("glass-button-secondary-50")) {
          btn.classList.add("glass-button-secondary-50");
        }
      });
    };

    addGlass();

    const timer = setTimeout(addGlass, 300);

    const observer = new MutationObserver(addGlass);
    observer.observe(target, { childList: true, subtree: true });

    return () => {
      clearTimeout(timer);
      observer.disconnect();
    };
  }, [element, options.target_id, theme.palette.mode, theme.palette.text.primary, theme.palette.primary.main]);

  return <div id={options.target_id} style={{ background: 'transparent' }}/>;
};

// export const CalendarSyncWrapper = ({ options, email }) => {
  //      #${options.target_id} button,
  //     #${options.target_id} button * {
  //       color: ${textColor} !important;
  //       border-color: ${borderColor} !important;
  //        padding: 2px 4px !important;
  // border-radius: 8px !important;
  //     }
//   // //console.log(options);
//   const [element, setElement] = useState(null);
//   const [isUpdate,setIsUpdate]=useState(false)
//   const [isCreate,setIsCreate]=useState(false)

//   // useEffect(() => {
//   //   if (!element) {
//   //     setElement(CronofyElements.CalendarSync(options));
//   //   }
//   // }, []);

//   // useEffect(() => {
//   //   if (element) {
//   //     element.update(options);
//   //   }
//   // }, [options]);

//   const handleUpdate = () => {
//     setIsUpdate(true)
//   };

//   const handleUpdateBack =()=>{
//     setIsUpdate(false)
//   }

//   const handleCreate = () => {
//     setIsCreate(true)
//   };

//   const handleCreateBack =()=>{
//     setIsCreate(false)
//   }

//   return (
//     <div id={options.target_id} >
//       <div >
//         <div style={{marginBottom:'10px'}}>
//           <Typography sx={{ fontSize: "14px", color: "#050C46",fontWeight:500 }}>{isCreate ? 'Select Source' : 'Calendar accounts'}</Typography>
//           {!isCreate ?( 
//           <TextField
//             value={email}
//             // disabled={isUpdate ? true : false}
//             variant="outlined"
//             size="small"
//             fullWidth
//             sx={{ flexGrow: 1,marginTop:"10px",color:'#050C46' }}
//             // onChange={(e) => setUserName(e.target.value)}
//             InputProps={{
//               startAdornment:isUpdate ?(
//                 <InputAdornment position="start">
//                   <img src={NoEdit} style={{marginLeft:'10px'}}/>
//                 </InputAdornment>
//               ) :null,
//               endAdornment: (
//                 <InputAdornment position="end">
//                   <p style={{fontSize:'14px',color:'#050C46',fontWeight:'600'}}>Active</p>
//                   <img src={ActiveIcon} style={{marginLeft:'10px'}}/>
//                 </InputAdornment>
//               )
//             }}
//           />) : (
//             <div style={{display:'flex',flexDirection:'row',margin:'10px'}}>
//               <Button variant="outlined" 
//               fullWidth
//               size="small"
//              className="createButton"
//              sx={{border:'1px solid #ECE9F5',margin: '10px'}}
//               startIcon={(
//                 <img src={GoogleIcon}/>
//               )}>
//                 Google
//               </Button>
//               <Button variant="outlined" 
//               fullWidth
//               size="small"
//               className="createButton"
//               sx={{border:'1px solid #ECE9F5',margin: '10px'}}
//               startIcon={(
//                 <img src={AppleIcon}/>
//               )}>
//                 iCloud
//               </Button>
//               <Button variant="outlined" 
//               fullWidth
//               size="small"
//               className="createButton"
//               sx={{border:'1px solid #ECE9F5',margin: '10px'}}
//               startIcon={(
//                 <img src={MicrosoftIcon}/>
//               )}>
//                 Office 365
//               </Button>
//               <Button variant="outlined" 
//               fullWidth
//               sx={{border:'1px solid #ECE9F5',margin: '10px'}}
//               size="small"
//               className="createButton"
//               startIcon={(
//                 <img src={ExchangeIcon}/>
//               )}>
//                 Exchange
//               </Button>
//               <Button variant="outlined" 
//               fullWidth
//               sx={{border:'1px solid #ECE9F5',margin: '10px'}}
//               size="small"
//               className="createButton"
//               startIcon={(
//                 <img src={Outlook}/>
//               )}>
//                 Outlook
//               </Button>
//             </div>
//           )}
//         </div>
//         <div style={{ display: "flex", flexDirection: "row" ,marginTop:"20px"}}>
//           {!isCreate && 
//           <Button
//             variant="outlined"
//             fullWidth
//             color="inherit"
//             size="small"
//             onClick={isUpdate ? handleUpdateBack :handleUpdate }
//             sx={{borderRadius:'8px',
//             color:'#050C46',
//             border:'1px solid #ECE9F5',
            
//           }}
//           >
//             {!isUpdate ?  "Edit account" :" Back"}
//           </Button>}
//           {!isUpdate && 
//            <Button
//             variant={isCreate ? "outlined" :"contained"}
//             fullWidth
//             color="inherit"
//             size="small"
//             onClick={ isCreate ? handleCreateBack :handleCreate}
//             sx={{
//               marginLeft:'10px',
//             borderRadius:'8px',
//             backgroundColor:!isCreate ? '#5761FE':'#F8F7FC',
//             border:isCreate ? '1px solid #ECE9F5' : '1px solid #5761FE',
//             color:isCreate ? '#050C46' : 'white',
//             '&:hover': {
//               backgroundColor: isCreate ? '#F8F7FC' : '#5761FE',
//             }
//           }}
//           startIcon={
//             !isCreate ? <img src={AddIcon} /> : null
//           }
//           >
//            {isCreate ? 'Back' : 'Add new account'}
//           </Button>}
//         </div>
//       </div>
//     </div>
//   );
// };
